"use strict";
/**
 * @module Services.TopicUpdate
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var update_stream_id_serialiser_1 = require("./update-stream-id-serialiser");
/**
 * Serialiser for {@link UpdateStreamRequest}
 */
var UpdateStreamRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(UpdateStreamRequestSerialiserClass, _super);
    function UpdateStreamRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link UpdateStreamRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link UpdateStreamRequest} to be written
     */
    UpdateStreamRequestSerialiserClass.prototype.write = function (bos, value) {
        update_stream_id_serialiser_1.UpdateStreamIdSerialiser.write(bos, value.streamId);
        Codec.writeBytes(bos, value.update);
    };
    return UpdateStreamRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.UpdateStreamRequestSerialiserClass = UpdateStreamRequestSerialiserClass;
/**
 * The {@link UpdateStreamRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.UpdateStreamRequestSerialiser = new UpdateStreamRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-update/update-stream-request-serialiser.js
// module id = 2070
// module chunks = 1